import { useTranslation } from "react-i18next";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ICON_COLOR, TeambookIcon } from "../default_images/TeambookIcon";
import { icons } from "../default_images/IconsList";
import PropTypes from "prop-types";

const PasswordRules = forwardRef(({ visible, password }, ref) => {
  const { t } = useTranslation();
  let letterRegex = /.*[^0-9].*/;
  let numberRegex = /.*[0-9].*/;
  let lengthRule = password.length >= 8;
  let letterRule = letterRegex.test(password);
  let numberRule = numberRegex.test(password);
  const [isPasswordBlurred, setIsPasswordBlurred] = useState(false);

  useImperativeHandle(ref, () => ({
    blurPassword: () => {
      if (password.length > 0) {
        setIsPasswordBlurred(true);
      }
    },
  }));

  useEffect(() => {
    if (password.length === 0) {
      setIsPasswordBlurred(false);
    }
  }, [password]);

  const rules = [
    {
      rule: lengthRule,
      text: t("auth.password_rule_1"),
    },
    {
      rule: letterRule,
      text: t("auth.password_rule_2"),
    },
    {
      rule: numberRule,
      text: t("auth.password_rule_3"),
    },
  ];

  return (
    visible &&
    password.length > 0 && (
      <div className="password-rules">
        {rules.map((rule, index) => {
          const icon = rule.rule ? "success" : isPasswordBlurred ? "error" : "•";
          const color = rule.rule ? "success" : isPasswordBlurred ? "error" : "default";

          return (
            <div key={index} className="password-rule">
              {icon === "success" ? (
                <TeambookIcon name={icons.CHECK} color={ICON_COLOR.COMMON} />
              ) : icon === "error" ? (
                <TeambookIcon name={icons.WARNING} color={ICON_COLOR.COMMON} />
              ) : (
                <div className="password-rule__dot">
                  <div className="password-rule__dot-inner" />
                </div>
              )}
              <p className={`${color}-rule `}>{rule.text}</p>
            </div>
          );
        })}
      </div>
    )
  );
});

PasswordRules.displayName = "PasswordRules";

PasswordRules.propTypes = {
  visible: PropTypes.bool.isRequired,
  password: PropTypes.string.isRequired,
  ref: PropTypes.object,
};

export default PasswordRules;
